var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tel-ui",attrs:{"slot":"icons"},slot:"icons"},[_c('a',{on:{"click":_vm.handleTel}},[_c('i'),_c('p',[_vm._v("联系商家")])])])}
var staticRenderFns = []

export { render, staticRenderFns }